/*
 * @Author: chenkailun
 * @Date: 2024-03-20 13:11:51
 * @LastEditors: chenkailun
 * @LastEditTime: 2024-10-12 15:15:26
 * @Description: 
 * @FilePath: \solarbiolite\src\store\modules\product.js
 */
import { getProductStock } from '../../api/product'
// initial state
const initState = {
	isShowProductModel: false,  // 筛选时商品列表是否出现浮层
	isShowclassify: false,
	isSearch: false, //判断是否调用搜索接口
	category: [],
	secondaryClass: '',
	is_new: 0,
	selectedcatId:null,
	claParentId: null,
	categoryId:null,
};

const state = {
	...initState,

	classifyTopId:null,
	selectedClassifyId: null,

	initState() {
		return initState
	}
}

// mutations
const mutations = {
	// 切换筛选时商品列表是否出现浮层 
	changeIsShowProductModel(state, value) {
		state.isShowProductModel = value;
	},
	setClaParentId(state, value) {
		state.claParentId = value;
	},
	setSelectedcatId(state, value) {
		state.selectedcatId = value;
	},
	setSelectedClassifyId(state, value) {
		state.selectedClassifyId = value;
	},
	setClassifyTopId(state, value) {
		state.classifyTopId = value;
	},
	setIsShowclassify(state, value) {
		state.isShowclassify = value;
	},
	defaultCategory(state, value) {
		state.category = value;
	},
	setSecondaryClass(state, value) {
		state.secondaryClass = value;
	},
	setNewProduct(state, value) {
		state.is_new = value;
	},
	changeSearch(state, value) {
		state.isSearch = value;
	},
	saveProductStock(state, data) {
		state.ProductStock = data;
	},

	saveCategoryId(state, data) {
		state.categoryId = data;
	},

}

// actions
const actions = {
	fetchHomeMenu({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			getProductStock(params.product_sn).then(
				(response) => {
					if (response) {
						commit('saveProductStock', response)
					}
					resolve(response)
				}, (error) => {
					reject(error)
				})
		})
	}
}


export default {
	state,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js